import Backbone from 'backbone'
import template from './notes-dialog.hbs'
import NotesView from 'scoreboard/notes/notes-view'
import _ from 'lodash'

var NotesDialog = Backbone.View.extend({

	className: 'notes-dialog',

	/**
	 * @param {ScorecardNode|Initiative} options.model
	 *
	 * @param {String} options.timeLabel label to show in the upper right corner
	 *
	 * @param {Number|Date} options.defaultTime the default time for the period selector when
	 * creating a new note.  it's either a periodId for scorecards, or a date for initiatives
	 *
	 * @param {Function} [options.filter] a filter for which notes should be displayed
	 *
	 * @constructs
	 */
	initialize: function(options) {
		this.options = options
	},

	render: function() {
		this.$el.append(template(this.options))

		this.notes = new NotesView(this.options).render()
		this.$('.dialog-body-content').append(this.notes.el)
		this.notes.on('change:notes', this.notes.render.bind(this.notes))
		this.notes.on('change:notes', function() {
			this.trigger('change:notes', this.model.get('notes'))
		}.bind(this))

		// If no notes shown and user cannot create notes, remove dark
		// class so it has the white background for the description text.
		// #15125 use NotesView to check, since metrics and initiatives use different models
		if (!this.notes.canCreateNotes() && !this.notes.hasNotes()) {
			this.$('.dialog-body').removeClass('dark')
		}

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.notes], 'remove')
	}

})

export default NotesDialog

NotesDialog.__filename__ = 'notes/notes-dialog.js'
